export default defineNuxtRouteMiddleware((to, from) => {
  function parseCookies(cookieString: string) {
    return cookieString.split(';').reduce((cookies, cookie) => {
      const [key, value] = cookie.split('=');
      if (key && value) {
        cookies[key.trim()] = decodeURIComponent(value.trim());
      }
      return cookies;
    }, {} as Record<string, string>);
  }

  if (process.server) {
    const cookies = useRequestHeaders(['cookie']).cookie || '';
    const canAuthDomain = parseCookies(cookies)?.can_auth_domain || false;
    if (!!canAuthDomain) {
      const event = useRequestEvent();
      event?.node.res.writeHead(302, { Location: 'https://my.sx.org' });
      event?.node.res.end();
      return;
    }
  }
})